import React from 'react';
import styled from 'styled-components';
import { HeaderProcessingIndicator } from './ProcessingIndicator';
// ... existing code ...

const HeaderContainer = styled.header`
  position: relative;
  background: linear-gradient(90deg, var(--brand-700), var(--brand-600));
  padding: 1.5rem 3rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  margin-bottom: 3rem;

  /* Tablet devices */
  @media (max-width: 1023px) {
    padding: 1.25rem 2rem;
    margin-bottom: 2.5rem;
  }

  /* Mobile devices */
  @media (max-width: 767px) {
    padding: 1rem 1.5rem;
    margin-bottom: 2rem;
  }

  /* Small mobile devices */
  @media (max-width: 479px) {
    padding: 1rem 1rem;
    margin-bottom: 1.5rem;
  }
`;

const Title = styled.h1`
  margin: 0 0 1.25rem 0;
  color: #fff;
  text-align: center;
  font-size: 2.5rem;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  line-height: 1.2;

  /* Tablet devices */
  @media (max-width: 1023px) {
    font-size: 2rem;
    margin: 0 0 1rem 0;
  }

  /* Mobile devices */
  @media (max-width: 767px) {
    font-size: 1.75rem;
    margin: 0 0 0.75rem 0;
  }

  /* Small mobile devices */
  @media (max-width: 479px) {
    font-size: 1.5rem;
    margin: 0 0 0.75rem 0;
  }
`;

const Subtitle = styled.p`
  margin: 0;
  color: rgba(255, 255, 255, 0.9);
  text-align: center;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.4;

  /* Tablet devices */
  @media (max-width: 1023px) {
    font-size: 1.1rem;
  }

  /* Mobile devices */
  @media (max-width: 767px) {
    font-size: 1rem;
  }

  /* Small mobile devices */
  @media (max-width: 479px) {
    font-size: 0.9rem;
  }
`;

const ProcessingIndicatorWrapper = styled.div`
  position: absolute;
  top: 1rem;
  right: 2rem;
  z-index: 10;

  /* Mobile devices */
  @media (max-width: 767px) {
    top: 0.75rem;
    right: 1.5rem;
  }

  /* Small mobile devices */
  @media (max-width: 479px) {
    top: 0.5rem;
    right: 1rem;
  }
`;

/**
 * Header - Application header component
 *
 * Features:
 * - Branded header with gradient background
 * - Application title and subtitle with desktop-optimized typography
 * - Desktop-first responsive design with mobile overrides
 * - Enhanced shadow and text effects for better desktop presentation
 * - Progressive typography scaling for different screen sizes
 */
export const Header: React.FC = () => {
  return (
    <HeaderContainer>
      <ProcessingIndicatorWrapper>
        <HeaderProcessingIndicator />
      </ProcessingIndicatorWrapper>

      <Title>Gestión de Consumos Energéticos</Title>
      <Subtitle>Panel de sostenibilidad para restaurantes</Subtitle>
    </HeaderContainer>
  );
};
